import { useTranslation } from 'react-i18next';
import './CardBrands.css';

// Bandeiras que os provedores ativos aceitam. Quem não tem ícone no
// Font Awesome usa uma sigla curta desenhada no mesmo quadrado do ícone.
export const CARD_BRANDS = [
    { key: 'visa', label: 'Visa', iconClass: 'fab fa-cc-visa' },
    { key: 'mastercard', label: 'Mastercard', iconClass: 'fab fa-cc-mastercard' },
    { key: 'amex', label: 'American Express', shortLabel: 'AMEX' },
    { key: 'elo', label: 'Elo', shortLabel: 'ELO' },
    { key: 'hipercard', label: 'Hipercard', shortLabel: 'HIPER' }
];

// Cada provedor devolve a bandeira com um nome diferente ("master", "american_express",
// "MasterCard"...). Aqui tudo vira a chave usada em CARD_BRANDS.
export const normalizeCardBrand = (brand) => {
    const normalizedBrand = String(brand || '').trim().toLowerCase().replace(/[\s_-]/g, '');

    if (normalizedBrand === 'master' || normalizedBrand === 'mastercard') {
        return 'mastercard';
    }

    if (normalizedBrand === 'americanexpress' || normalizedBrand === 'amex') {
        return 'amex';
    }

    return normalizedBrand;
};

// Detecção local pelos primeiros dígitos (BIN). Serve só para o retorno visual
// enquanto o operador digita; a validação real é sempre a do provedor.
export const detectCardBrand = (rawNumber) => {
    const number = String(rawNumber || '').replace(/\D/g, '');

    if (number.length < 4) return null;

    if (/^4/.test(number)) return 'visa';
    if (/^(5[1-5]|2[2-7])/.test(number)) return 'mastercard';
    if (/^3[47]/.test(number)) return 'amex';
    if (/^(606282|3841)/.test(number)) return 'hipercard';
    if (/^(4011|4312|4389|504175|506699|5067|509|627780|636297|636368|650|651|655)/.test(number)) return 'elo';

    return null;
};

/**
 * Faixa de bandeiras aceitas exibida acima do número do cartão. Enquanto nada
 * foi identificado, mostra todas em cinza; ao detectar, a bandeira do cartão
 * ganha cor e as demais recuam, para o operador enxergar de relance que o
 * cartão foi reconhecido.
 *
 * @param {string|null} brand bandeira detectada, em qualquer grafia de provedor
 */
const CardBrands = ({ brand, className = '' }) => {

    const { t } = useTranslation();

    const normalizedBrand = normalizeCardBrand(brand);
    const activeBrand = CARD_BRANDS.find((item) => item.key === normalizedBrand) || null;

    return (
        <div className={`card-brands${activeBrand ? ' is-detected' : ''}${className ? ` ${className}` : ''}`}>
            <div className="card-brands__header">
                <span className="card-brands__eyebrow">{t('card_flag')}</span>
                <span className="card-brands__status">
                    {activeBrand ? (
                        <>
                            <i className="fa-solid fa-circle-check" aria-hidden="true"></i>
                            {activeBrand.label}
                        </>
                    ) : (
                        t('card_brand_auto_detect_hint')
                    )}
                </span>
            </div>

            <div className="card-brands__list" role="list">
                {CARD_BRANDS.map((item) => {
                    const isActive = item.key === activeBrand?.key;

                    return (
                        <div
                            key={item.key}
                            role="listitem"
                            className={`card-brands__chip card-brands__chip--${item.key}${isActive ? ' is-active' : ''}`}
                            title={item.label}
                            aria-label={item.label}
                        >
                            {item.iconClass ? (
                                <i className={item.iconClass} aria-hidden="true"></i>
                            ) : (
                                <span className="card-brands__short-label">{item.shortLabel}</span>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CardBrands;
